export const caretLeftIcon = `
        <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9815 4.19194C12.2794 3.94786 12.2794 3.55214 11.9815 3.30806C11.6836 3.06398 11.2006 3.06398 10.9027 3.30806L6.32596 7.05806C6.03718 7.29467 6.02708 7.67566 6.30304 7.92233L10.4984 11.6723C10.7831 11.9268 11.2656 11.944 11.5761 11.7107C11.8867 11.4775 11.9077 11.0821 11.623 10.8277L7.92115 7.5188L11.9815 4.19194Z" fill="#00ABC7"/>
</svg>

`
